<template>
  <div class="bot repair">
    <div class="content">
      <div class="repair" :ref="message.id"></div>
    </div>

    <div class="time">
      <span v-if="typingCompleted"> {{ message.createAt | localTime }}</span>
    </div>
  </div>
</template>

<script>
import Typed from "typed.js";
export default {
  name: "gpt-message-bot-repair",
  props: {
    message: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      showAll: false,
      typingCompleted: false,
    };
  },
  mounted() {
    const el = this.returnMessage.repairStatus;
    if (this.checkTyped(this.message.id)) {
      this.$refs[this.message.id].insertAdjacentHTML("beforeend", el);
      this.typingCompleted = true;
    } else {
      this.startTying(el);
    }
  },
  methods: {
    startTying(el) {
      const vm = this;
      new Typed(this.$refs[this.message.id], {
        strings: [el],
        showCursor: false,
        typeSpeed: 10,
        loop: false,
        onComplete: function() {
          vm.setTyped(vm.message.id);
          vm.typingCompleted = true;
          if (vm.returnMessage.status === "SUCCESS") {
            vm.$store.dispatch(
              "gpt/createBotSettingMessage",
              "ChatGPT_Repair_Record"
            );
          }
        },
      });
    },
    checkTyped(id) {
      let data = localStorage.getItem("asus_chat_gpt_typed") || [];
      return data.includes(id);
    },
    setTyped(id) {
      let data = JSON.parse(localStorage.getItem("asus_chat_gpt_typed")) || [];
      data.push(id);
      localStorage.setItem("asus_chat_gpt_typed", JSON.stringify(data));
    },
  },
  computed: {
    returnMessage() {
      const result = JSON.parse(this.message.content).Result;
      const returnMessage = () => {
        try {
          return JSON.parse(result.ReturnMessage);
        } catch (e) {
          return result.ReturnMessage;
        }
      };
      if (typeof returnMessage() === "object") {
        return returnMessage();
      } else {
        return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "gpt.scss";
</style>
